<template>
  <b-card no-body>
    <b-card-header>
      <slot />
      <b-card-title>Opmerking</b-card-title>
    </b-card-header>
    <b-card-body body-bg-variant="light">
      <b-row 
        v-for="(foto,index) in gebrek.thumbs" 
        :key="index"
      >
        <b-card 
          no-body 
          class="overflow-hidden" 
          style="max-height:300px;"
        >
          <b-row no-gutters>
            <b-col 
              md="6" 
              class="d-flex align-items-center"
            >
              <b-card-img 
                :src="foto.secure_url" 
                class="rounded-0 img-fluid card-img-top"
              />
            </b-col>
            <b-col md="6">
              <b-card-body :title="(index+1) + ' ' + (foto.titel || 'Geen')">
                <b-card-text>
                  <b-button
                    size="sm"
                    class="mx-2"
                    variant="danger"
                    @click="gebrek.thumbs.splice(index, 1);"
                  >
                    <i class="fa fa-trash" />
                  </b-button>
                  <b-form-text>
                    {{ foto.created_at | formatDateTime }}
                    <small>{{ foto.public_id.substring(0,45)+".." }}</small>
                  </b-form-text>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-row>
      <b-button @click="fotoboek=!fotoboek">
        <i class="fa fa-photo mr-2" /> Toevoegen foto s
      </b-button>
      <b-modal 
        v-model="fotoboek" 
        title="Kies foto" 
        size="lg"
      >
        <media-grid
          :url="apiCloudResources + '/gebreken'"
          :uploadfolder="cloudUploadPath + '/gebreken'"
          @foto-select="gebrek.thumbs.push($event)"
        />
      </b-modal>
    </b-card-body>
    <b-card-body>
      <b-form-group 
        v-if="gebrek.bedrag == null" 
        label="Omschrijving"
      >
        <b-textarea v-model="gebrek.omschrijving" />
      </b-form-group>
      <b-form-group label="Opgelost">
        <b-checkbox v-model="gebrek.uitgevoerd" />
      </b-form-group>
    </b-card-body>
  </b-card>
</template>
<script>
import MediaGrid from "@/components/MediaGrid";
export default {
  name: "OpmerkingInvoer",
  components: {
    MediaGrid,
  },
  props: {
    gebrek: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      fotoboek: false
    };
  },
  computed: {
    apiCloudResources: function() {
      return "/media/cloudinary/" + this.$route.params.id;
    },
    // direct upload path
    cloudUploadPath: function() {
      return "/data/" + this.$route.params.id;
    }
  },
};
</script>